import styled from 'styled-components'
import { LinkButton } from 'components/common/typography'
import { maxContainerWidth, gutter } from 'components/globalStyles'
import { TransparentButton } from 'components/common/common_styles'
import { Link } from 'gatsby'

export const OuterContainer = styled.nav`
  width: 100%;
  height: 88px;
  position: fixed;
  top: 0;
  z-index: 100;
  background: ${props => (props.isScrolled ? 'white' : 'linear-gradient(180deg, rgba(27, 22, 22, 0.6) 0%, rgba(27, 22, 22, 0) 100%)')};
  color: ${props => (props.isScrolled ? 'var(--spBlack)' : 'white')};
  display: flex;
  justify-content: center;
`

export const MenuButton = styled(TransparentButton)`
  font-size: inherit;
`

export const InnerContainer = styled.div`
  width: 100%;
  max-width: ${maxContainerWidth};
  display: flex;
  align-items: center;
  gap: clamp(40px, 9.09vw - 71px, 60px);
  padding-left: ${gutter};
  transition: all 0.25s;

  & > ul {
    display: flex;
    align-items: center;
    gap: clamp(40px, 9.09vw - 71px, 60px);
    font-family: Garamond;
    font-size: 1.8rem;
    letter-spacing: 0.05rem;

    & > li {
      position: relative;
      white-space: nowrap;

      & > a,
      ${MenuButton} {
        color: ${props => (props.isScrolled ? 'var(--spBlack)' : 'white')};
        text-decoration: none;
        display: flex;
        align-items: center;
        white-space: nowrap;
        gap: 6px;
      }
    }
  }

  & a {
    font-weight: normal;
  }
`

export const BookButton = styled(LinkButton)`
  font-size: 1.8rem;
  border: none;
  background: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
  color: ${props => (props.$isScrolled ? 'white' : 'var(--spBlack)')};
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 2.7rem;
  transition: none;

  &:hover {
    background: ${props => (props.$isScrolled ? 'white' : 'var(--spBlack)')};
    color: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
    transition: all 0.4s;
  }
`

export const Arrow = styled.div`
  display: inline-block;
  font-size: 1.2em;
  line-height: 0;
  transform: translateY(1px);
`

export const IconContainer = styled.div`
  display: flex;
  margin-left: auto;
  gap: 30px;
  align-items: center;
`

export const AccountLink = styled(Link)`
  display: flex;
  text-decoration: none;
  color: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
  font-family: Garamond;

  & p {
    margin-right: 8px;
  }

  & div {
    color: ${props => (props.$isScrolled ? 'var(--spBlack)' : 'white')};
  }
`

export const CartLink = styled(AccountLink)`
  position: relative;
  margin-left: 0;
  gap: 4px;
`

export const SubmenuContainer = styled.nav`
  position: absolute;
  left: -16px;
  padding: 24px 24px 0 16px;
  z-index: 100;
  background: white;
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  font-family: Garamond;
  font-size: 1.8rem;
  line-height: 2.16rem;

  transition-property: opacity, visibility;
  transition-duration: 0.25s, 0s;
  transition-delay: 0s, 0.25s;

  & a,
  & p {
    color: var(--spBlack);
    text-decoration: none;
    font-family: Garamond;
    font-size: 1.8rem;
    line-height: 2.16rem;
  }

  & li {
    padding-bottom: 24px;
  }

  ${InnerContainer} > ul > li:hover &,
  ${InnerContainer} > ul > li:focus-within & {
    visibility: visible;
    opacity: 1;
    transition-delay: 0s, 0s;
  }
`
